// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExcessContributionFileResponseDto
 */
export interface IExcessContributionFileResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IExcessContributionFileResponseDto
     */
    file_url?: string;
    /**
     * 
     * @type {string}
     * @memberof IExcessContributionFileResponseDto
     */
    s3key?: string;
}

/**
 * Check if a given object implements the IExcessContributionFileResponseDto interface.
 */
export function instanceOfIExcessContributionFileResponseDto(value: object): value is IExcessContributionFileResponseDto {
    return true;
}

export function IExcessContributionFileResponseDtoFromJSON(json: any): IExcessContributionFileResponseDto {
    return IExcessContributionFileResponseDtoFromJSONTyped(json, false);
}

export function IExcessContributionFileResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExcessContributionFileResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        's3key': json['s3key'] == null ? undefined : json['s3key'],
    };
}

export function IExcessContributionFileResponseDtoToJSON(json: any): IExcessContributionFileResponseDto {
    return IExcessContributionFileResponseDtoToJSONTyped(json, false);
}

export function IExcessContributionFileResponseDtoToJSONTyped(value?: IExcessContributionFileResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_url': value['file_url'],
        's3key': value['s3key'],
    };
}

